module.exports = __webpack_public_path__ + "static/media/products_services4.8617cc92.jpg";